<template>
  <div
    class='theme-input__field-holder'
    :class="{
      'theme-input__field-holder--error': !!errors.has(newName),
      'theme-input__field-holder--focused': isFocused,
    }"
    data-vv-value-path='model'
    :data-vv-as='label'
  >
    <label class='theme-input__label' v-if='labelHtml' v-html='labelHtml'></label>
    <label class='theme-input__label' v-else-if='label'>
      {{ label }}
      <span v-if='isRequired' class='theme-input__label-asterisk'>*</span>
    </label>
    <div class='theme-input__wrapper'>
      <input
        :class="['theme-input', {
          'theme-input--green': green,
          'theme-input--blue': blue,
          'theme-input--extra': isExtraInfo,
        }]"
        v-model='model'
        :type='type || `text`'
        :name='name'
        :disabled='disabled'
        :placeholder='placeholder'
        :min='min'
        :max='max'
        :readonly='isReadonly'
        @change="$emit('change', $event)"
        @blur="
          $emit('blur', $event);
          isFocused = false;
        "
        @focus="
          $emit('focus', $event);
          isFocused = true;
        "
      />
      <span
        v-if='errors.has(newName)'
        class='icon-warning theme-input__icon theme-input__icon-error'
        :class="{'theme-input__icon-error-password': type === 'password'}">
      </span>
      <i
        v-if="type == 'password'"
        class='fa fa-eye-slash'
        style='right: 14px; cursor: pointer; position: absolute; top: 18px'
        @click='togglePassword'
        :title='locales && locales.common && locales.common.show_password'
      />
      <div class='theme-input__extra-info' v-if='isExtraInfo'>
        <slot name='extra-info'></slot>
      </div>
    </div>
    <div class='theme-input__extra-note' v-if='isExtraNote'>
      <slot name='extra-note'></slot>
    </div>
    <div class='theme-input__error-text' v-if='errors.has(newName)'>
      {{ errors.first(newName) }}
    </div>
  </div>
</template>

<script>
  import field from '../admin/mixins/field';
  import {mapGetters} from 'vuex';
  import {isReadonly} from 'vue';

  export default {
    data() {
      return {
        isFocused: false,
      };
    },
    computed: {
      ...mapGetters(['locales']),
    },
    mounted() {},
    mixins: [field],
    props: {
      placeholder: {
        default: '',
        type: String,
      },
      min: {
        default: '',
        type: [String, Number],
      },
      max: {
        default: '',
        type: String,
      },
      labelHtml: {
        default() {
          return '';
        },
        type: String,
      },
      isExtraInfo: {
        default: false,
        type: Boolean,
      },
      isExtraNote: {
        default: false,
        type: Boolean,
      },
      isRequired: {
        default: false,
        type: Boolean,
      },
      green: {
        default: false,
        type: Boolean,
      },
      blue: {
        default: false,
        type: Boolean,
      },
      isReadonly: {
        default: false,
        type: Boolean,
      },
    },
    methods: {
      togglePassword(e) {
        var togglePassword = $(e.target);
        var password = togglePassword.parent().find('[name=\'' + this.name + '\']').first();
        var type = password.attr('type') === 'password' ? 'text' : 'password';
        password.attr('type', type);
        togglePassword.toggleClass('fa-eye');
        togglePassword.toggleClass('fa-eye-slash');
      },
    },
  };
</script>



// WEBPACK FOOTER //
// resources/js/components/ThemeInput.vue